import { Children, useEffect } from 'react';

const requiredValidator = (error) => {
    return (element) => {
        if (!element.props.value || !element.props.value.length){
            return error;
        }
    };
}

const addAutomaticValidations = (element, validations) => {
    // If data-required-if property evaluates to false, then just return.
    if (element.props && element.props['data-required-if'] !== undefined && !element.props['data-required-if']) {
        return;
    }

    if (element.props && element.props['data-required'] && element.props['data-required'].length){
        validations.push(requiredValidator(element.props['data-required']));
    }
    else if (element.props && element.props['data-required'] && !element.props['data-required'].length){
        validations.push(requiredValidator('This field is required.'));
    }
};

const getElementValidationMessage = (element, validations) => {
    let validationMessage = '';
    
    if (element.props && validations && validations.length){
        validations.forEach(validation => {
            const msg = validation(element);
            
            if (msg && !validationMessage.length){
                validationMessage = msg;
            }
        });
    }

    return validationMessage;
};

function ValidatedElement({ children, validations, validationEnabled, setValidationError}) {
    let elements = Children.toArray(children);
    validations = validations ?? [];

    let elementsWithValidation = [];
    let firstValidationMessage = '';

    for (var i = 0; i < elements.length; i++){
        let element = elements[i];
        elementsWithValidation.push(elements);

        addAutomaticValidations(element, validations);
        const validationMessage = getElementValidationMessage(element, validations);
        
        if (validationMessage.length && !firstValidationMessage.length){
            firstValidationMessage = validationMessage;
        }

        if (validationEnabled){
            elementsWithValidation.push(
                <span key={element.props.name} className={validationMessage ? 'field-validation-error' : 'field-validation-valid'}>
                    {validationMessage}
                </span>
            );
        }
    }

    useEffect(() => {
        setValidationError(firstValidationMessage);
    });

    return (
        <>
            {elementsWithValidation}
        </>
    );
}

export default ValidatedElement;
